import Step from '@mui/material/Step';
import StepButton from '@mui/material/StepButton';
import MuiStepper from '@mui/material/Stepper';
import StepperConnector from './StepperConnector';
import StepperIcon from './StepperIcon';

export default function Stepper({ steps, activeStep, onStepClick, sx = {} }) {
  return (
    <MuiStepper
      activeStep={activeStep}
      alternativeLabel
      nonLinear
      connector={<StepperConnector />}
      sx={sx}
    >
      {steps.map((step, idx) => (
        <Step
          key={step.key}
          completed={step.completed}
          disabled={step.disabled}
          sx={{
            ':first-of-type': { paddingLeft: 0 },
            ':last-of-type': { paddingRight: 0 },
          }}
        >
          <StepButton
            onClick={() => onStepClick?.(idx)}
            disabled={step.disabled}
            icon={
              <StepperIcon
                active={idx === activeStep}
                completed={step.completed}
                in_progress={step.in_progress}
                disabled={step.disabled}
              />
            }
          >
            <div className='column gap-0'>
              <span>{step.stepLabel || step.label}</span>
              {step.meta && <span className='text--secondary'>{step.meta}</span>}
            </div>
          </StepButton>
        </Step>
      ))}
    </MuiStepper>
  );
}
